import CascadeVote from '../../vote/Cascade.vue'
import ChoiceMoreRank from '../../vote/ChoiceMoreRank.vue'
import { createPopup } from '../../assets/js/factory'

export default {
  mixins: [CascadeVote],
  computed: {
    voteItems() {
      const vote = this.question.vote
      const oidCountMap = Object.assign({}, vote.oidCountMap)
      const val = this.issue.value.slice()
      val.forEach(id => {
        oidCountMap[id] = (oidCountMap[id] || 0) + 1
      })
      const data = { ...vote, oidCountMap, totalNum: vote.totalNum + 1 }
      return this.getAllVoteItems(data)
    }
  },
  methods:{
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        question: this.question,
        items: this.voteItems
      })
    },
  },
}